import React, { useEffect, useState} from "react";
import BASEURL from "../../../Utils/Baseurl";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  ButtonGroup,
  FormControl,
  FormHelperText,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Add } from "@mui/icons-material";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialTypography from "../../../../components/MaterialTypography";

import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";

import { useNavigate } from "react-router-dom";

import { Delete } from "@mui/icons-material";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import loading from "../../../../assest/images/loading.svg";
import error from "../../../../assest/images/404.svg";
import Swal from "sweetalert2";
import { useUserDetails } from "../../../../context/auth";

import { useLoading } from "../../../../context/loading";

const AddHoliday = () => {
  const navigate = useNavigate();
  const [id, setId] = useState(null);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const { setCirleLoading } = useLoading();
  const { viewdisplay, setviewdisplay, AccessData } = useUserDetails();
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedYearErr, setSelectedYearErr] = useState("unchecked");
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });
  const [publicHolidays, setPublicHolidays] = useState([
    {
      event: "",
      date: "",
      type: "",
      eventErr: "unchecked",
      dateErr: "unchecked",
      typeErr: "unchecked",
    },
  ]);
  const [originalHolidayData, setOriginalHoliday] = useState([
    { event: "", date: "", type: "" },
  ]);
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [viewpublic, setviewpublic] = useState(false);

  const currentYear = new Date().getFullYear();

  const endyear = 2099;
  const years = [];

  for (let year = currentYear; year <= endyear; year++) {
    years.push(year);
  }

  const yearOptions = years.map((year) => ({
    value: year,
    label: year.toString(),
  }));

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    }
  }, []);

  const onHolidaySubmit = async () => {
    const query = `mutation addHolidays($input: HolidayInput!) {
  addHoliday(input: $input) {
    message
    success
    error
    }
  }`;
    setCirleLoading(true);
    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,

          variables: {
            input: {
              year: selectedYear?.value || null,
              event: publicHolidays?.map((item) => item.event),
              eventDate: publicHolidays?.map((item) => item.date),
              holidayType: publicHolidays?.map((item) => item.type?.value),
            },
          },
        }),
      });

      let result = response.data?.data?.addHoliday;

      if (result?.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Holiday Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        navigate("/holiday");
      } else {
        setConfirmationDialog({
          open: true,
          title: "Error",
          message: result?.message || "Failed to create holiday.",
          showCancel: true,
          showConfirm: false,
          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const onHolidayEdit = async () => {
    const query = `
   mutation edit_holiday($input: EditHolidayInput!){ 

  editHoliday(input: $input){ 

    message 

    success 

    error 

  } 

} 
    `;
    setCirleLoading(true);
    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,

          variables: {
            input: {
              year: selectedYear?.value || null,
              id: [id],
              event: publicHolidays?.map((item) => item.event),
              eventDate: publicHolidays?.map((item) => item.date),
              holidayType: publicHolidays?.map((item) => item.type?.value),
            },
          },
        }),
      });

      let result = response.data;

      if (result !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Holiday Edited Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }

      // Handling success
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      navigate("/holiday");
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteSubmitHoliday();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteSubmitHoliday = async () => {
    const query = `
           mutation delete_holiday($id: [ID]){ 
   deleteHoliday(id: $id){ 
     message 
     success 
     error 
   } 
 } 
        `;
    setCirleLoading(true);
    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: [id],
        },
      });

      if (response.data.data.deleteHoliday.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Holiday Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/holiday");
      } else {
        console.error(
          "Error deleting Holiday:",
          response.data.data.deleteHoliday.message
        );
      }
    } catch (error) {
      console.error("An error occurred while deleting the Holiday:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  const getInitData = async (id) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });
    const query = `
    query get_holiday_by_id($id: String!){ 
   holidayById(id:$id){ 
     id 
     event 
     eventDate 
     year 
     holidayType 
   } 
 } 
 `;
    setCirleLoading(true);
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data?.data?.holidayById;
      setSelectedYear({
        label: data?.year,
        value: data?.year,
      });
      setSelectedYearErr("success");
      const temp = [
        {
          event: data?.event,
          date: data?.eventDate,
          type: { value: data?.holidayType, label: data?.holidayType },
          eventErr: "success",
          dateErr: "success",
          typeErr: "success",
        },
      ];
      setPublicHolidays(temp);
      setOriginalHoliday(temp);
      setTogglePage({
        ...togglePage,
        view: true,
      });
    } catch (error) {
      console.error("ResponseError:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleAddHoliday = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onHolidaySubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const handldEditHoliday = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onHolidayEdit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const onDiscardHoliday = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setPublicHolidays(originalHolidayData);
  };

  const confirmDeletePublic = (id) => {
    setPublicHolidays(publicHolidays.filter((holiday, ind) => ind !== id));
  };

  const onAddPublicHoliday = () => {
    setPublicHolidays([...publicHolidays, { event: "", date: "", type: "" }]);
  };

  const handleHoliday = (e, id, type) => {
    if (type !== "year") {
      const temp = [...publicHolidays];
      if (type == "type") {
        temp[id] = {
          ...temp[id],
          [type]: e,
          ["typeErr"]: "success",
        };
      } else if (e?.target?.name == "event") {
        const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,20})$");
        if (alphaNLengthRegex.test(e.target.value?.trim())) {
          temp[id] = {
            ...temp[id],
            [e?.target?.name]: e.target.value,
            [e?.target?.name + "Err"]: "success",
          };
        } else {
          temp[id] = {
            ...temp[id],
            [e?.target?.name]: e.target.value,
            [e?.target?.name + "Err"]: "error",
          };
        }
      } else {
        temp[id] = {
          ...temp[id],
          [e?.target?.name]: e.target.value,
          [e?.target?.name + "Err"]: "success",
        };
      }
      setPublicHolidays(temp);
    } else {
      setSelectedYear(e);
      setSelectedYearErr("success");
    }
  };

  const leaveType = [
    { value: "Restricted", label: "Restricted" },
    { value: "Public", label: "Public" },
  ];

  const disabledFun = () => {
    let temp = false;
    const days = publicHolidays?.every((item) =>
      Object.values(item).every((value) => value !== "")
    );

    if (selectedYearErr == "success" && days) {
      temp = false;
    } else {
      temp = true;
    }
    return temp;
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Holiday details
                    </MaterialTypography>
                  </Stack>
                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) =>
                        item.component === "AddHoliday" && item.can_access
                    ) &&
                    pageState.state !== "submitting" && (
                      <ButtonGroup
                        variant="outlined"
                        aria-label="Loading button group"
                      >
                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          onClick={toggleEdit}
                          startIcon={<EditIcon />}
                        >
                          Edit
                        </MaterialButton>
                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          onClick={AddDelete}
                          startIcon={<DeleteIcon />}
                        >
                          Delete
                        </MaterialButton>
                      </ButtonGroup>
                    )}
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Add Holiday Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent
          sx={{
            minHeight: pageState.state === "submitting" ? "65vh" : "70vh",
          }}
        >
          {pageState.state === "error" && (
            <MaterialBox>
              <Grid container spacing={1} textAlign="center">
                <Grid size={{ xs: 12, sm: 12 }}>
                  <img
                    src={error}
                    alt="error"
                    style={{
                      width: "30%",
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography variant="h6" fontWeight="bold">
                      {pageState.message}
                    </MaterialTypography>
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          )}

          {!viewpublic && (
            <MaterialBox>
              <MaterialTypography
                sx={{ mt: 2, mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
                variant="h5"
                fontWeight="bold"
              >
                Holiday <span style={{ color: "red" }}>*</span>
              </MaterialTypography>

              <MaterialBox>
                <Grid container spacing={2} mb={1}>
                  <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Year
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialSelect
                      name="year"
                      options={yearOptions}
                      value={selectedYear}
                      onChange={(e) => handleHoliday(e, "", "year")}
                      customStyles={{ optionPadding: 20 }}
                      isDisabled={togglePage.view}
                      error={selectedYearErr === "error" ? true : false}
                      success={selectedYearErr === "success" ? true : false}
                    />
                  </Grid>
                </Grid>
                <Divider style={{ marginTop: 1 }} />
                {publicHolidays.map((day, index) => (
                  <MaterialBox key={day.id}>
                    <Grid container spacing={2} mb={1}>
                      {/* S.No Label + Input */}
                      <Grid item size={{ xs: 12, sm: 4, lg: 1 }}>
                        <MaterialBox
                          mb={1}
                          ml={0.5}
                          lineHeight={0}
                          textAlign="left"
                        >
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                          >
                            S.No
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          name="sNo"
                          value={index + 1}
                          readOnly
                          disabled
                        />
                      </Grid>
                      {/* Event Label + Input */}
                      <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
                        <MaterialBox
                          mb={1}
                          ml={0.5}
                          lineHeight={0}
                          textAlign="left"
                        >
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                          >
                            Event
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          name="event"
                          placeholder="Event"
                          value={day.event}
                          onChange={(e) => handleHoliday(e, index)}
                          disabled={togglePage.view}
                          error={day?.eventErr === "error" ? true : false}
                          success={day?.eventErr === "success" ? true : false}
                        />
                        {day.eventErr === "error" && (
                          <FormControl error>
                            <FormHelperText>
                              Event must be a maximum of 20 characters
                            </FormHelperText>
                          </FormControl>
                        )}
                      </Grid>
                      {/* Date Label + Input */}
                      <Grid item size={{ xs: 12, sm: 4, lg: 3 }}>
                        <MaterialBox
                          mb={1}
                          ml={0.5}
                          lineHeight={0}
                          textAlign="left"
                        >
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                          >
                            Date
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          name="date"
                          placeholder="Date"
                          type="date"
                          value={day.date}
                          onChange={(e) => handleHoliday(e, index)}
                          inputProps={{
                            min: (() => {
                              const today = new Date();
                              const year = today.getFullYear();
                              const month = String(
                                today.getMonth() + 1
                              ).padStart(2, "0"); // months are 0-indexed
                              const day = String(today.getDate()).padStart(
                                2,
                                "0"
                              );
                              return `${selectedYear?.value}-${month}-${day}`;
                            })(),
                            // min: new Date().toISOString().split("T")[0],
                            max: new Date(`${selectedYear?.value}-12-31`)
                              .toISOString()
                              .split("T")[0],
                          }}
                          error={day?.dateErr === "error" ? true : false}
                          success={day?.dateErr === "success" ? true : false}
                          disabled={togglePage.view || !selectedYear}
                        />
                      </Grid>
                      <Grid item size={{ xs: 12, sm: 4, lg: 3 }}>
                        <MaterialBox
                          mb={1}
                          ml={0.5}
                          lineHeight={0}
                          textAlign="left"
                        >
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                          >
                            Holiday Type
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                          name="type"
                          value={day?.type}
                          customStyles={{ optionPadding: 20 }}
                          onChange={(e) => handleHoliday(e, index, "type")}
                          options={leaveType.map((value) => {
                            return {
                              value: value.value,
                              label: value.label,
                            };
                          })}
                          error={day?.typeErr === "error" ? true : false}
                          success={day?.typeErr === "success" ? true : false}
                          isDisabled={togglePage.view}
                        />
                      </Grid>
                      {!togglePage.view && !togglePage.edit && (
                        <Grid item size={{ xs: 12, sm: 4, lg: 1 }}>
                          <MaterialButton
                            onClick={() => confirmDeletePublic(index)}
                            variant="gradient"
                            color="error"
                            fullWidth
                            style={{ marginTop: "20px" }}
                          >
                            <Delete color="inherit" />
                          </MaterialButton>
                        </Grid>
                      )}
                      {/* Delete Button */}
                    </Grid>
                    <Divider />
                  </MaterialBox>
                ))}
              </MaterialBox>
              {!togglePage.view && !togglePage.edit && (
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  startIcon={<Add />}
                  onClick={onAddPublicHoliday}
                  mb={0}
                  pb={0}
                >
                  Add
                </MaterialButton>
              )}
            </MaterialBox>
          )}

          {pageState.state === "submitting" && !pageState.loading && (
            <MaterialBox>
              <MaterialBox
                justifyContent="center"
                alignItems="center"
                display="flex"
                flexDirection="column"
                minHeight="50vh"
              >
                <MaterialTypography
                  variant="h6"
                  fontWeight="bold"
                  textAlign="center"
                >
                  Adding your holidaySubmit data. This should not take much
                  time.
                </MaterialTypography>
                <MaterialBox mt={2}>
                  <img src={loading} alt="loading" width="200px" />
                </MaterialBox>
              </MaterialBox>
            </MaterialBox>
          )}
        </CardContent>
        {pageState.state !== "submitting" && (
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            {togglePage.edit === true ? (
              <>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  disabled={pageState.state === "submitting"}
                  onClick={onDiscardHoliday}
                >
                  Discard
                </MaterialButton>

                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={disabledFun()}
                  onClick={handldEditHoliday}
                >
                  Update
                </MaterialButton>
              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={disabledFun()}
                onClick={handleAddHoliday}
              >
                Submit
              </MaterialButton>
            ) : null}
          </MaterialBox>
        )}
        {
          <MaterialSnackbar
            color="success"
            icon={<NotificationsIcon />}
            title="Message"
            content="You have been submitted successfully"
            open={snackBar.Success}
            close={() =>
              setSnackBar({
                success: false,
              })
            }
          />
        }
      </Card>
    </DashboardLayout>
  );
};

export default AddHoliday;
